import { gql } from "graphql-request";

export const StoryFieldsFragment = gql`
  fragment StoryFieldsFragment on StorySearchResult {
    storyId
    name
    subdomain
    publicationId
    publicationTitle
  }
`;
